// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCUwiCSeEd3s0cBnZOMYpqOjK898vaag6g",
  authDomain: "cvjservices-76b8d.firebaseapp.com",
  projectId: "cvjservices-76b8d",
  storageBucket: "cvjservices-76b8d.firebasestorage.app",
  messagingSenderId: "806534338772",
  appId: "1:806534338772:web:c2cdbc8402802745fa0341",
  measurementId: "G-W43GH476JK"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export {app, auth, analytics, db};